/*
  Lesson times arrive as UTC (the portal's register.classTime). They are shown in the phone's own
  time zone, exactly as the portal's convertTimeFromUTC does with moment-timezone.
*/
import moment from "moment-timezone";
import "moment/locale/en-gb";

moment.locale("en-gb");
moment.updateLocale("en-gb", { week: { dow: 1, doy: 4 } });

export const local = (utcIso: string) => moment.utc(utcIso).tz(moment.tz.guess());

export const fmtTime = (utcIso: string) => local(utcIso).format("h:mma");
export const fmtDayLong = (utcIso: string) => local(utcIso).format("dddd D MMMM");
export const fmtDayShort = (utcIso: string) => local(utcIso).format("ddd D MMM");
export const isoDay = (utcIso: string) => local(utcIso).format("YYYY-MM-DD");

export function relativeDay(utcIso: string): string {
  const d = local(utcIso).startOf("day");
  const today = moment().startOf("day");
  const diff = d.diff(today, "days");
  if (diff === 0) return "Today";
  if (diff === 1) return "Tomorrow";
  if (diff === -1) return "Yesterday";
  if (diff > 1 && diff < 7) return d.format("dddd");
  return d.format("ddd D MMM");
}

export function chatDay(iso: string): string {
  const d = moment(iso).startOf("day");
  const today = moment().startOf("day");
  const diff = today.diff(d, "days");
  if (diff === 0) return "Today";
  if (diff === 1) return "Yesterday";
  if (diff < 7) return d.format("dddd");
  return d.format(d.year() === today.year() ? "D MMMM" : "D MMMM YYYY");
}

export const minutesUntil = (utcIso: string) => Math.round((new Date(utcIso).getTime() - Date.now()) / 60000);

export type LessonPhase = "live" | "soon" | "upcoming" | "past";
export function lessonPhase(start: string, end: string, now = Date.now()): LessonPhase {
  const s = new Date(start).getTime(); const e = new Date(end).getTime();
  if (now >= s && now < e) return "live";
  if (now < s && s - now <= 3 * 3600 * 1000) return "soon";
  if (now < s) return "upcoming";
  return "past";
}

export const timeZoneName = () => moment.tz.guess();
